// eslint-disable-next-line import/prefer-default-export
export const theme = (state = null) => state
